const GATE_URL = "https://gate.stonksfolio.com"
const FALLBACK_URL = "/tools/prices"

async function get(url) {
  const response = await fetch(url, { headers: { Accept: "application/json" } })
  if (!response.ok) throw new Error(`${response.status} ${url}`)
  return response.json()
}

function normalize(data) {
  if (data.currency !== "GBp") return data
  return { ...data, currency: "GBP", closes: data.closes?.map((close) => close / 100), price: data.price && data.price / 100 }
}

export async function search(term, fallbackUrl) {
  const results = await get(`${GATE_URL}/search?q=${encodeURIComponent(term)}`).then((data) => data.results).catch(() => [])
  if (results.length > 0 || !fallbackUrl) return results

  const securities = await get(`${fallbackUrl}?term=${encodeURIComponent(term)}`).catch(() => [])
  return securities
    .filter((security) => security.yahoo_finance_symbol)
    .map((security) => ({ symbol: security.yahoo_finance_symbol, name: security.name, exchange: security.currency, type: "" }))
}

export async function quote(symbol) {
  try {
    return normalize(await get(`${GATE_URL}/quote/${encodeURIComponent(symbol)}`))
  } catch {
    const data = normalize(await get(`${FALLBACK_URL}/${encodeURIComponent(symbol)}`))
    return { symbol: data.symbol, currency: data.currency, name: data.name, price: data.closes[data.closes.length - 1], date: data.dates[data.dates.length - 1] }
  }
}

export async function quoteInEuros(symbol) {
  const data = await quote(symbol)
  if (data.currency === "EUR") return { ...data, priceEur: data.price }

  const rate = await quote(`EUR${data.currency}=X`)
  return { ...data, priceEur: data.price / rate.price }
}

export async function chart(symbol) {
  try {
    return normalize(await get(`${GATE_URL}/chart/${encodeURIComponent(symbol)}`))
  } catch {
    return normalize(await get(`${FALLBACK_URL}/${encodeURIComponent(symbol)}`))
  }
}
